
'use strict';

define('component!AcademyPaneComponent',['require','prop-types','react','create-react-class','translate','mixins/ReflowMixin','mixins/TransitionMixin','lib/RightPaneMediator','component!AcademyProgressBar','classnames'],function (require) {
  'use strict';

  var PropTypes = require('prop-types');

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var t = require('translate');
  var ReflowMixin = require('mixins/ReflowMixin');
  var TransitionMixin = require('mixins/TransitionMixin');
  var rightPane = require('lib/RightPaneMediator');
  var AcademyProgressBar = require('component!AcademyProgressBar');

  var AcademyPaneComponent = ReactCreateClass({
    displayName: 'AcademyPaneComponent',

    mixins: [ReflowMixin, TransitionMixin],

    propTypes: {
      eventBus: PropTypes.any.isRequired
    },

    getDefaultProps: function getDefaultProps() {
      return {
        translations: {
          dismiss: t('Dismiss #academy_pane_close_button')
        }
      };
    },

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    componentDidMount: function componentDidMount() {
      // Trigger a reflow before manipulating state
      this.reflow();

      this.UNSAFE_componentWillReceiveProps({
        isOpen: true
      });
    },

    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen && !this.state.isOpen) {
        var register = (function () {
          return rightPane.register({
            id: this,
            open: this.setState.bind(this, { isOpen: true }),
            close: this._handlePaneCloseCallback
          });
        }).bind(this);

        register().fail(function (errorCode) {
          if (errorCode === 'IN_PROGRESS') {
            setTimeout(register, 250);
          }
        });
      } else if (!nextProps.isOpen && this.state.isOpen) {
        rightPane.unregister({
          id: this
        });
      }
    },

    render: function render() {
      var cx = require('classnames');
      var classes = cx({
        'academy-pane-component': true,
        'is-open': this.state.isOpen
      });

      return React.createElement(
        'aside',
        { className: classes, ref: 'aside' },
        React.createElement(
          'a',
          { className: 'academy-pane-component-close', onClick: this.handleClose, title: this.props.translations.dismiss },
          '✕'
        ),
        this._getHeader(),
        this.props.children
      );
    },

    _getHeader: function _getHeader() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'header',
          { className: 'academy-pane-component__header' },
          React.createElement(
            'h2',
            { ref: 'heading', className: 'citrixsans' },
            this.props.heading
          ),
          React.createElement(
            'p',
            { ref: 'subHeading' },
            this.props.subHeading
          )
        ),
        React.createElement(AcademyProgressBar, { course: this.props.course })
      );
    },

    _handlePaneCloseCallback: function _handlePaneCloseCallback() {
      this.setState({ isOpen: false });

      this.props.eventBus.trigger('academy:didClose');
    },

    handleClose: function handleClose() {
      rightPane.unregister({
        id: this
      });

      this.props.eventBus.trigger('academy:closeClicked');
    }
  });

  return AcademyPaneComponent;
});
